import axios from "@/libs/api.request";
import { xinli } from "./api_url";
/**
 * 新增机构
 * @param data
 * @returns {*|{responseURL}}
 */
export const company_add = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.company_add,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 机构列表
 * @param {*} data
 * @returns
 */
export const company_list = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.company_list,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 机构列表
 * @param {*} data
 * @returns
 */
export const company_update = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.company_update,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 删除机构
 * @param {*} data
 * @returns
 */
export const company_del = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.company_del,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 保存机构介绍
 * @param {*} data
 * @returns
 */
export const company_desc_save = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.company_desc_save,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 新增机构密码
 * @param {*} data
 * @returns
 */
export const companypass_add = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.companypass_add,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 机构密码列表
 * @param {*} data
 * @returns
 */
export const companypass_list = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.companypass_list,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 编辑机构密码
 * @param {*} data
 * @returns
 */
export const companypass_update = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.companypass_update,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 删除机构编码
 * @param {*} data
 * @returns
 */
export const companypass_del = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.companypass_del,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 删除机构编码
 * @param {*} data
 * @returns
 */
export const companypass_file_upload = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request(
    {
      url: xinli.companypass_file_upload,
      data: {
        ...data,
        country_code
      },
      method: "post"
    },
    "FormData"
  );
};
/**
 * 获取咨询师列表
 * @param {*} data
 * @returns
 */
export const expert_list = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.expert_list,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 新增咨询师
 * @param {*} data
 * @returns
 */
export const expert_add = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.expert_add,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 编辑咨询师
 * @param {*} data
 * @returns
 */
export const expert_update = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.expert_update,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 删除咨询师
 * @param {*} data
 * @returns
 */
export const expert_del = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.expert_del,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 删除专题
 * @param {*} data
 * @returns
 */
export const special_del = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.special_del,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 编辑专题
 * @param {*} data
 * @returns
 */
export const special_update = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.special_update,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 专题列表
 * @param {*} data
 * @returns
 */
export const special_list = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.special_list,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 专题列表添加
 * @param {*} data
 * @returns
 */
export const special_add = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.special_add,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 获取密码列表和专题列表
 * @param {*} data
 * @returns
 */
export const get_testcat_password = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.get_testcat_password,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 导入试题文件（xls或xlsx）
 * @param {*} data
 * @returns
 */
export const exam_import = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request(
    {
      url: xinli.exam_import,
      data: {
        ...data,
        country_code
      },
      method: "post"
    },
    "FormData"
  );
};
/**
 * 获取题库列表
 * @param {*} data
 * @returns
 */
export const exam_list = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.exam_list,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 删除题库
 * @param {*} data
 * @returns
 */
export const exam_del = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.exam_del,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 下载题库
 * @param {*} data
 * @returns
 */
export const exam_download = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.exam_download,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 评测记录列表
 * @param {*} data
 * @returns
 */
export const testlog_list = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.testlog_list,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 评测记录详情
 * @param {*} data
 * @returns
 */
export const testlog_detail = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.testlog_detail,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 导出试卷
 * @param {*} data
 * @returns
 */
export const testlog_export = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.testlog_export,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 咨询师分析
 * @param {*} data
 * @returns
 */
export const tongji_expert = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.tongji_expert,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};

/**
 * 专题分析
 * @param {*} data
 * @returns
 */
export const tongji_special = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.tongji_special,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 用户分析
 * @param {*} data
 * @returns
 */
export const tongji_user = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.tongji_user,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 导出数据详情
 * @param {*} data
 * @returns
 */
export const data_detail_export = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.data_detail_export,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 预约记录
 * @param {*} data
 * @returns
 */
export const appoint_list = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.appoint_list,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 启用禁用
 * @param {*} data
 * @returns
 */
export const publicspecial_handle = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.publicspecial_handle,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 公开课列表
 * @param {*} data
 * @returns
 */
export const publicspecial_list = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.publicspecial_list,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 新增公开课
 * @param {*} data
 * @returns
 */
export const publicspecial_add = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.publicspecial_add,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 删除公开课
 * @param {*} data
 * @returns
 */
export const publicspecial_del = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.publicspecial_del,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 编辑公开课
 * @param {*} data
 * @returns
 */
export const publicspecial_update = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.publicspecial_update,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 导出测评记录
 * @param {*} data
 * @returns
 */
export const appoint_export = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.appoint_export,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 上传图片
 * @param {*} data
 * @returns
 */
export const upload_pic = data => {
  let country_code = localStorage.getItem("country_code");
  data.append("country_code", country_code);
  return axios.request(
    {
      url: xinli.upload_pic,
      data:data ,
      method: "post"
    },
    "FormData"
  );
};
/**
 * 审核预约记录
 * @param {*} data
 * @returns
 */
export const appoint_review = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.appoint_review,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 新增分类
 * @param {*} data
 * @returns
 */
export const testcat_add = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.testcat_add,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 新增分类
 * @param {*} data
 * @returns
 */
export const testcat_list = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.testcat_list,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 新增分类
 * @param {*} data
 * @returns
 */
export const testcat_del = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.testcat_del,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 新增分类
 * @param {*} data
 * @returns
 */
export const testcat_update = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: xinli.testcat_update,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
